import { render, staticRenderFns } from "./Cat1.vue?vue&type=template&id=5da3abc3"
import script from "./Cat1.vue?vue&type=script&lang=js"
export * from "./Cat1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports